import { useDispatch, useSelector } from "react-redux";
import dynamicfunction from "../../utils/dynamicfunction";
import { useEffect, useState } from "react";
import { getContentKeyAccToLang } from "../../utils/utils";
import { getAccountReport } from "../../store/actions/settingAction";
import { setAccountReport } from "../../store/slices/settingSlice";

export default () => {
  const dispatch = useDispatch();
  const { TextWeight, isArabic } = dynamicfunction();
  const { reportsContent } = useSelector((state) => state.content);
  const { settingLoading, accountReport } = useSelector(
    (state) => state.setting
  );

  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [emailModal, setEmailModal] = useState(false);
  const [recipient, setRecipient] = useState(0);
  const [isView, setIsView] = useState(false);

  useEffect(() => {
    dispatch(setAccountReport(null))
  }, [])

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      reportsContent?.web_account_statement?.data?.attributes,
      key,
      isArabic
    );
  };

  const toogleEmailModal = () => setEmailModal(!emailModal);

  const handleViewReport = (year) => {
    if (year?.year && selectedMonth) {
      dispatch(getAccountReport(`${selectedMonth?.key}-${year?.year}`));
    }
  };

  const onSendEmail = () => {
    const apiData = {
      reportName: accountReport?.title,
      date: `${selectedYear?.year}-${selectedMonth?.key}-01`,
    };
  }

  return {
    isArabic,
    TextWeight,
    settingLoading,
    selectedMonth,
    recipient,
    emailModal,
    selectedYear,
    accountReport,
    setSelectedYear,
    setSelectedMonth,
    setRecipient,
    getContentKey,
    toogleEmailModal,
    handleViewReport,
    isView,
    setIsView,
    onSendEmail,
  };
};
